import { createReducer, on } from '@ngrx/store';
import {
  STORE_CHANNEL_FIND_SUCCESS,
  STORE_CHANNEL_FAILURE,
  STORE_CHANNEL_UPDATE_FORM,
  STORE_CHANNEL_RESET_ERROR,
  STORE_CHANNEL_RESET,
  STORE_CHANNEL_RESET_FORM,
  STORE_CHANNEL_FIND_ALL_SUCCESS,
  STORE_CHANNEL_FIND_ALL_CONFIGURATION_SUCCESS,
  STORE_CHANNEL_EDIT_MODE,
} from '../actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  LocalCanal,
  LocalCanalConfiguracion,
  LocalCanalForm,
} from '@core/models';
import { transformStoreChannelData, transformStoreChannelForm } from '@core/helpers';

export interface StoreChannelState {
  loading: boolean;
  editMode: boolean;
  storeChannel: LocalCanal | null;
  storeChannelList: LocalCanal[] | null;
  storeChannelConfigurationList: LocalCanalConfiguracion[] | null;
  storeChannelForm: LocalCanalForm | null;
  error: ResponseBadRequest | null;
}

export const initialState: StoreChannelState = {
  loading: false,
  editMode: false,
  storeChannel: null,
  storeChannelList: [],
  storeChannelConfigurationList: [],
  storeChannelForm: null,
  error: null,
};

export const storeChannelReducer = createReducer(
  initialState,
  on(STORE_CHANNEL_EDIT_MODE, (state, { editMode }) => ({ ...state, editMode })),
  on(STORE_CHANNEL_FIND_SUCCESS, (state, { storeChannel }) => ({ ...state, storeChannel: transformStoreChannelData(storeChannel) })),
  on(STORE_CHANNEL_FIND_ALL_SUCCESS, (state, { storeChannelList }) => ({ ...state, storeChannelList })),
  on(STORE_CHANNEL_FIND_ALL_CONFIGURATION_SUCCESS, (state, { storeChannelConfigurationList }) => ({ ...state, storeChannelConfigurationList })),
  on(STORE_CHANNEL_FAILURE, (state, { error }) => ({ ...state, error })),
  on(STORE_CHANNEL_UPDATE_FORM, (state, { storeChannelForm }) => ({ ...state, storeChannelForm: transformStoreChannelForm(storeChannelForm) })),
  on(STORE_CHANNEL_RESET, (state) => ({ ...state, storeChannel: initialState.storeChannel })),
  on(STORE_CHANNEL_RESET_ERROR, (state) => ({ ...state, error: initialState.error })),
  on(STORE_CHANNEL_RESET_FORM, (state) => ({ ...state, storeChannelForm: initialState.storeChannelForm, loading: initialState.loading })),
);